/**
 * Define namespace
 *
 */
var Intesa = Intesa || {};


Intesa.TicketingComplaint = function() {

        console.log("started-ticketingComplaint");

        /**
         * Local variables
         *
         */
        var bank = $('html').attr('data-bank');
        var language = $('html').attr('lang');
        var ticketingComplaint = this;
        this.responseTicketing = {};
        this.activeReasons = {};
        this.activeSpecifyType = {};
        this.activeSubReasons = {};
        this.typeSegment = $('input[name="segment"]')[0]?$('input[name="segment"]')[0].value:"";
        this.chooseTypeValue = "";
        this.chooseReason = "";
        this.chooseSubReason = "";
        this.mobileOrDesktop = false;
        this.textParagraph = "";
        /**
         * Init component
         *
         */
        this.init = function() {
        	if(bank == "BIB"){
            var widthWindow = $(window).width();
            var checkMobile = widthWindow < 768 ? false : true;
            ticketingComplaint.callWs();

            ticketingComplaint.mobileOrDesktop = checkMobile;
            console.log(widthWindow);
            if (!checkMobile) {
                ticketingComplaint.mobileOrDesktop = false;
            } else {
                ticketingComplaint.mobileOrDesktop = true;
            }
            ticketingComplaint.createButtonTypeValue();
            ticketingComplaint.attemptEventsTypeValue();
            ticketingComplaint.attemptEventsSubmit();
            if ($(".modale-ticket-complaint"))
                ticketingComplaint.eventsModale();
            ticketingComplaint.eventsModaleSubmit();
            ticketingComplaint.textParagraph = $(".individuals-reason .for__gridWrapperTabs__title.specifyTitle").text();
            ticketingComplaint.controlEmailAndPhone();
        	}

        };

        /*
	
        	method init

        */

        this.callWs = function() {

            var callTicketing = $('[data-ticket-complaint]').get(0);
            var response;

            if (callTicketing) {

                var host = window.location.origin;
                var endpoint = host + $('[data-ticket-complaint]').get(0).getAttribute('data-endpoint');
                //TEST URL
                //endpoint = "https://virtserver.swaggerhub.com/OpenReplyIT/bib-complaints-api/v1-oas3/ticketTypes";

                $.ajax({
                    type: "GET",
                    url: endpoint,
                    contentType: "application/json",
                    crossDomain: true,
                    dataType: "json",
                    async: false,
                    success: function(data) {
                        //local
                        if (host == "http://localhost:8080") {
                        	response = data.types;
                        } else {
                        	response = data.types;
                        }
                        console.log("Succes: true, ----with response: " + JSON.stringify(data) + "----");
                    },
                    error: function(data) {
                        console.log("Error with response:" + data);
                    }
                });
                
              //PER TEST
              //var response = [{"typeValue":"Prigovor","typeValueEnglesh":"Complaint","typeId":2,"reasons":[{"reasonValue":"Kartice","reasonValueEnglish":"Cards","subReasons":[{"subReasonId":"170","subReasonValue":"Kreditne kartice Amex","subReasonValueEnglesh":"Credit cards Amex","subReasonSegmentList":["INDIVIDUAL"]},{"subReasonId":"162","subReasonValue":"Debitne kartice","subReasonValueEnglesh":"Debit cards","subReasonSegmentList":["INDIVIDUAL"]},{"subReasonId":"154","subReasonValue":"Business debitne kartice","subReasonValueEnglesh":"Business debit cards","subReasonSegmentList":["LEGAL_ENTITY"]},{"subReasonId":"186","subReasonValue":"Kreditne kartice Visa","subReasonValueEnglesh":"Credit cards Visa","subReasonSegmentList":["INDIVIDUAL"]},{"subReasonId":"178","subReasonValue":"Kreditne kartice MaterCard","subReasonValueEnglesh":"Credit cards MaterCard","subReasonSegmentList":["INDIVIDUAL"]},{"subReasonId":"503","subReasonValue":"Business kreditne kartice","subReasonValueEnglesh":"Business credit cards","subReasonSegmentList":["LEGAL_ENTITY"]}],"reasonId":"5"},{"reasonValue":"Bankomati","reasonValueEnglish":"ATM","subReasons":[{"subReasonId":"146","subReasonValue":"Bankomat","subReasonValueEnglesh":"ATM","subReasonSegmentList":["INDIVIDUAL","LEGAL_ENTITY"]}],"reasonId":"8"},{"reasonValue":"Digitalni servisi","reasonValueEnglish":"Digital Services","subReasons":[{"subReasonId":"138","subReasonValue":"Digitalni servisi- fiziÄka lica","subReasonValueEnglesh":"Digital services - Retail","subReasonSegmentList":["INDIVIDUAL"]},{"subReasonId":"578","subReasonValue":"Digitalni servisi - pravna lica","subReasonValueEnglesh":"Digital services - Legale entities","subReasonSegmentList":["LEGAL_ENTITY"]}],"reasonId":"6"},{"reasonValue":"PlaÄ‡anja","reasonValueEnglish":"Payments","subReasons":[{"subReasonId":"130","subReasonValue":"Dinarski raÄuni i platni promet","subReasonValueEnglesh":"Dinar accounts and payments","subReasonSegmentList":["INDIVIDUAL","LEGAL_ENTITY"]},{"subReasonId":"122","subReasonValue":"Devizni raÄuni i platni promet","subReasonValueEnglesh":"Foreign currency account and payments","subReasonSegmentList":["INDIVIDUAL","LEGAL_ENTITY"]}],"reasonId":"4"},{"reasonValue":"Å tednja","reasonValueEnglish":"Savings","subReasons":[{"subReasonId":"114","subReasonValue":"Depoziti","subReasonValueEnglesh":"F/X Deposits","subReasonSegmentList":["LEGAL_ENTITY"]},{"subReasonId":"333","subReasonValue":"Depoziti devizni","subReasonValueEnglesh":"F/X Deposits","subReasonSegmentList":["INDIVIDUAL"]},{"subReasonId":"293","subReasonValue":"Dinarski depoziti","subReasonValueEnglesh":"Dinar deposits","subReasonSegmentList":["INDIVIDUAL","LEGAL_ENTITY"]},{"subReasonId":"353","subReasonValue":"Ostali depoziti","subReasonValueEnglesh":"Other deposits","subReasonSegmentList":["INDIVIDUAL","LEGAL_ENTITY"]}],"reasonId":"2"},{"reasonValue":"Krediti","reasonValueEnglish":"Loans","subReasons":[{"subReasonId":"106","subReasonValue":"Stambeni krediti","subReasonValueEnglesh":"Mortgage loans","subReasonSegmentList":["INDIVIDUAL"]},{"subReasonId":"98","subReasonValue":"PotroÅ¡aÄki krediti","subReasonValueEnglesh":"Customer loans","subReasonSegmentList":["INDIVIDUAL"]},{"subReasonId":"82","subReasonValue":"Auto krediti","subReasonValueEnglesh":"Car loans","subReasonSegmentList":["INDIVIDUAL"]},{"subReasonId":"413","subReasonValue":"RPG Krediti","subReasonValueEnglesh":"Agro loans","subReasonSegmentList":["INDIVIDUAL","LEGAL_ENTITY"]},{"subReasonId":"373","subReasonValueEnglesh":"Cash loans senior","subReasonValue":"Gotovinski senior keÅ¡ kredit","subReasonSegmentList":["INDIVIDUAL"]},{"subReasonId":"363","subReasonValueEnglesh":"Cash loans Laki Kes","subReasonValue":"Gotovinski laki keÅ¡ kredit","subReasonSegmentList":["INDIVIDUAL"]},{"subReasonId":"492","subReasonValueEnglesh":"Other loans","subReasonValue":"Ostali krediti","subReasonSegmentList":["LEGAL_ENTITY"]},{"subReasonId":"481","subReasonValueEnglesh":"Cash loan for entrepreneurs","subReasonValue":"Krediti za preduzetnike","subReasonSegmentList":["LEGAL_ENTITY"]},{"subReasonId":"383","subReasonValueEnglesh":"Cash loans intermezzo","subReasonValue":"Gotovinski intermezzo keÅ¡ kredit","subReasonSegmentList":["INDIVIDUAL"]},{"subReasonId":"403","subReasonValueEnglesh":"Refinancing cash loan","subReasonValue":"Krediti za refinansiranje","subReasonSegmentList":["INDIVIDUAL"]}],"reasonId":"1"},{"reasonValue":"Ostalo","reasonValueEnglish":"Other","subReasons":[{"subReasonId":"202","subReasonValue":"Ostalo","subReasonValueEnglesh":"Other","subReasonSegmentList":["INDIVIDUAL","LEGAL_ENTITY"]}],"reasonId":"10"},{"reasonValue":"Ekspoziture","reasonValueEnglish":"Branches","subReasons":[{"subReasonId":"194","subReasonValue":"Ekspoziture","subReasonValueEnglesh":"Branches","subReasonSegmentList":["INDIVIDUAL","LEGAL_ENTITY"]}],"reasonId":"9"},{"reasonValue":"Rad zaposlenih","reasonValueEnglish":"Employee service","subReasons":[{"subReasonId":"210","subReasonValue":"Rad radnika","subReasonValueEnglesh":"Our employee service","subReasonSegmentList":["INDIVIDUAL","LEGAL_ENTITY"]}],"reasonId":"7"},{"reasonValue":"Dozvoljeno prekoraÄenje raÄuna","reasonValueEnglish":"Overdraft","subReasons":[{"subReasonId":"475","subReasonValue":"Dozvoljeno prekoraÄenje raÄuna","subReasonValueEnglesh":"Overdraft","subReasonSegmentList":["INDIVIDUAL","LEGAL_ENTITY"]}],"reasonId":"3"}]},{"typeValue":"Molba","typeValueEnglesh":"Request","typeId":5,"reasons":[{"reasonValue":"Krediti","reasonValueEnglish":"Loans","subReasons":[{"subReasonId":"406","subReasonValue":"Krediti za refinansiranje","subReasonValueEnglesh":"Refinancing cash loan","subReasonSegmentList":["INDIVIDUAL"]},{"subReasonId":"484","subReasonValue":"Krediti za preduzetnike","subReasonValueEnglesh":"Cash loan for entrepreneurs","subReasonSegmentList":["LEGAL_ENTITY"]},{"subReasonId":"496","subReasonValue":"Ostali krediti","subReasonValueEnglesh":"Other loans","subReasonSegmentList":["LEGAL_ENTITY"]},{"subReasonId":"366","subReasonValue":"Gotovinski laki keÅ¡ kredit","subReasonValueEnglesh":"Cash loans Laki Kes","subReasonSegmentList":["INDIVIDUAL"]},{"subReasonId":"376","subReasonValue":"Gotovinski senior keÅ¡ kredit","subReasonValueEnglesh":"Cash loans senior","subReasonSegmentList":["INDIVIDUAL"]},{"subReasonId":"416","subReasonValue":"RPG Krediti","subReasonValueEnglesh":"Agro loans","subReasonSegmentList":["INDIVIDUAL","LEGAL_ENTITY"]},{"subReasonId":"85","subReasonValue":"Auto krediti","subReasonValueEnglesh":"Car loans","subReasonSegmentList":["INDIVIDUAL"]},{"subReasonId":"101","subReasonValue":"PotroÅ¡aÄki krediti","subReasonValueEnglesh":"Customer loans","subReasonSegmentList":["INDIVIDUAL"]},{"subReasonId":"109","subReasonValue":"Stambeni krediti","subReasonValueEnglesh":"Mortgage loans","subReasonSegmentList":["INDIVIDUAL"]}],"reasonId":"1"},{"reasonValue":"Dozvoljeno prekoraÄenje raÄuna","reasonValueEnglish":"Overdraft","subReasons":[{"subReasonId":"466","subReasonValue":"Dozvoljeno prekoraÄenje raÄuna","subReasonValueEnglesh":"Overdraft","subReasonSegmentList":["INDIVIDUAL","LEGAL_ENTITY"]}],"reasonId":"3"},{"reasonValue":"Kartice","reasonValueEnglish":"Cards","subReasons":[{"subReasonId":"507","subReasonValue":"Business kreditne kartice","subReasonValueEnglesh":"Business credit cards","subReasonSegmentList":["LEGAL_ENTITY"]},{"subReasonId":"181","subReasonValue":"Kreditne kartice MasterCard","subReasonValueEnglesh":"Credit cards MaterCard","subReasonSegmentList":["INDIVIDUAL"]},{"subReasonId":"189","subReasonValue":"Kreditne kartice Visa","subReasonValueEnglesh":"Credit cards Visa","subReasonSegmentList":["INDIVIDUAL"]},{"subReasonId":"157","subReasonValue":"Business debitne kartice","subReasonValueEnglesh":"Business debit cards","subReasonSegmentList":["LEGAL_ENTITY"]},{"subReasonId":"165","subReasonValue":"Debitne kartice","subReasonValueEnglesh":"Debit cards","subReasonSegmentList":["INDIVIDUAL"]},{"subReasonId":"173","subReasonValue":"Kreditne kartice Amex","subReasonValueEnglesh":"Credit cards Amex","subReasonSegmentList":["INDIVIDUAL"]}],"reasonId":"5"},{"reasonValue":"Å tednja","reasonValueEnglish":"Savings","subReasons":[{"subReasonId":"356","subReasonValue":"Ostali depoziti","subReasonValueEnglesh":"Other deposits","subReasonSegmentList":["INDIVIDUAL","LEGAL_ENTITY"]},{"subReasonId":"296","subReasonValue":"Dinarski depoziti","subReasonValueEnglesh":"Dinar deposits","subReasonSegmentList":["INDIVIDUAL","LEGAL_ENTITY"]},{"subReasonId":"336","subReasonValue":"Depoziti devizni","subReasonValueEnglesh":"F/X Deposits","subReasonSegmentList":["INDIVIDUAL"]},{"subReasonId":"117","subReasonValue":"Depoziti","subReasonValueEnglesh":"F/X Deposits","subReasonSegmentList":["LEGAL_ENTITY"]}],"reasonId":"2"},{"reasonValue":"Rad zaposlenih","reasonValueEnglish":"Employee service","subReasons":[{"subReasonId":"213","subReasonValue":"Rad radnika","subReasonValueEnglesh":"Our employee service","subReasonSegmentList":["INDIVIDUAL","LEGAL_ENTITY"]}],"reasonId":"7"},{"reasonValue":"Ekspoziture","reasonValueEnglish":"Branches","subReasons":[{"subReasonId":"197","subReasonValue":"Ekspoziture","subReasonValueEnglesh":"Branches","subReasonSegmentList":["INDIVIDUAL","LEGAL_ENTITY"]}],"reasonId":"9"},{"reasonValue":"Ostalo","reasonValueEnglish":"Other","subReasons":[{"subReasonId":"205","subReasonValue":"Ostalo","subReasonValueEnglesh":"Other","subReasonSegmentList":["INDIVIDUAL","LEGAL_ENTITY"]}],"reasonId":"10"},{"reasonValue":"PlaÄ‡anja","reasonValueEnglish":"Payments","subReasons":[{"subReasonId":"125","subReasonValue":"Devizni raÄuni i platni promet","subReasonValueEnglesh":"Foreign currency account and payments","subReasonSegmentList":["INDIVIDUAL","LEGAL_ENTITY"]},{"subReasonId":"133","subReasonValue":"Dinarski raÄuni i platni promet","subReasonValueEnglesh":"Dinar accounts and payments","subReasonSegmentList":["INDIVIDUAL","LEGAL_ENTITY"]}],"reasonId":"4"},{"reasonValue":"Digitalni servisi","reasonValueEnglish":"Digital Services","subReasons":[{"subReasonId":"141","subReasonValue":"Digitalni servisi- fiziÄka lica","subReasonValueEnglesh":"Digital services - Retail","subReasonSegmentList":["INDIVIDUAL"]},{"subReasonId":"579","subReasonValue":"Digitalni servisi - pravna lica","subReasonValueEnglesh":"Digital services - Legale entities","subReasonSegmentList":["LEGAL_ENTITY"]}],"reasonId":"6"},{"reasonValue":"Bankomati","reasonValueEnglish":"ATM","subReasons":[{"subReasonId":"149","subReasonValue":"Bankomat","subReasonValueEnglesh":"ATM","subReasonSegmentList":["INDIVIDUAL","LEGAL_ENTITY"]}],"reasonId":"8"}]}];
              var stringResponse = JSON.stringify(response);
              if(bank == "BIB" && language.indexOf('en') > -1){ 
            	  if(stringResponse.includes("typeValueEnglesh") || stringResponse.includes("typeValueEnglish")){
	            	  stringResponse = stringResponse.replace(/"typeValue"/g, '"typeValueSr"');
	            	  stringResponse = stringResponse.replace(/"typeValueEnglesh"/g, '"typeValue"');
	            	  stringResponse = stringResponse.replace(/"typeValueEnglish"/g, '"typeValue"');
	            	  
	            	  stringResponse = stringResponse.replace(/"reasonValue"/g, '"reasonValueSr"');
	            	  stringResponse = stringResponse.replace(/"reasonValueEnglesh"/g, '"reasonValue"');
	            	  stringResponse = stringResponse.replace(/"reasonValueEnglish"/g, '"reasonValue"');
	            	  
	            	  stringResponse = stringResponse.replace(/"subReasonValue"/g, '"subReasonValueSr"');
	            	  stringResponse = stringResponse.replace(/"subReasonValueEnglesh"/g, '"subReasonValue"');
	            	  stringResponse = stringResponse.replace(/"subReasonValueEnglish"/g, '"subReasonValue"');
            	  }
              }
              
              ticketingComplaint.responseTicketing = JSON.parse(stringResponse);

            }
        }

        this.attemptEventsSubmit = function() {

            $(document).on('click', '[data-submit-ticketing-status]', function() {

                var inquiryNumber = $('input[name="inquirycode"]').get(0).value;
                var hashTag = $('input[name="hashtag"]').get(0).value;

                var host = window.location.origin;
                var endpoint = host + $('[data-submit-ticketing-status]').get(0).getAttribute('data-endpoint-form-ticketing-platform');

                if (inquiryNumber !== null && hashTag !== null && endpoint !== 'undefined' &&
                    inquiryNumber !== '' && hashTag !== '') {

                    $('[data-form-ticket-platform]').get(0).style.display = "none";
                    $('[data-form-ticket-processing]').get(0).style.display = "block";

                    var paramiters = "&inquiryNumber=" + inquiryNumber + "&hashTag=" + hashTag;
                    var endpoint = endpoint + paramiters;

                    $.ajax({
                        type: "GET",
                        url: endpoint,
                        contentType: "application/json",
                        dataType: "json",
                        async: false,
                        success: function(data) {
                            //responseTicketing = ticketingComplaint.responseTicketing = JSON.parse('{"values":'+data+'}');			
                            //ticketingComplaint.responseTicketing = data;
                            //console.log("Succes: true, ----with response: " + JSON.stringify(data) +"----");
                            $('[data-form-ticket-processing]').get(0).style.display = "none";

                            //DataLayer
                            var dataLayer = sessionStorage.getItem("jsonFormSubmit");
                            sessionStorage.setItem("jsonFormSubmit", "");
                            if (dataLayer != null && dataLayer != 'undefined') {
                                //								var outcome = "Request accepted";					
                                //								data = data.replace("[OUTCOME]", outcome);								
                                dataLayer = JSON.parse(dataLayer);
                                window.dataLayer.push(dataLayer);
                            }

                            console.log("inquiryNumber: " + data.inquiryNumber + "----");
                            console.log("hashTag: " + data.hashTag + "----");
                            console.log("submissionDate: " + data.submissionDate + "----");
                            console.log("status: " + data.status + "----");
                            var statusTicket = data.status;
                            if (statusTicket.includes("processing") || statusTicket.includes("obrade")) {
                                $('[data-form-ticket-processing]').get(0).style.display = "block";
                            } 
                            else if (statusTicket.includes("404") || statusTicket.includes("nije pronađen") || statusTicket.includes("GENERIC ERROR")) {
                                $('[data-form-ticket-not-found]').get(0).style.display = "block";
                            } 
                            else if (statusTicket.includes("is accepted") || statusTicket.includes("je prihvaćen")) {
                                $('[data-form-ticket-success]').get(0).style.display = "block";
                            } 
                            else {
                                $('[data-form-ticket-error]').get(0).style.display = "block";
                            }
                        },
                        error: function(data) {
                            $('[data-form-ticket-processing]').get(0).style.display = "none";
                            $('[data-form-ticket-error]').get(0).style.display = "block";
                            console.log("Error with response:" + data);
                        }
                    });
                }
            });

        }


        this.eventsModaleSubmit = function() {
            if ($('.modale-submit-ticketing')[0]) {
                /*var inquiry = $("#inquiryNumberValue").val();
                var hashtag = $("#hashTagValue").val();

                var textInquiry = $(".description-modale").text();
                var textHashTag = $(".paragraph-ticketing-right").text();

                $(".description-modale").text(textInquiry.replace("[value]", inquiry));
                $(".paragraph-ticketing-right").text(textHashTag.replace("string", hashtag));

                $('.modale-submit-ticketing')[0].style.display = "block";*/
                $(document).on('click', '.close-submit-ticketing', function() {
                    $('.modale-submit-ticketing').get(0).style.display = "none";
                });
            }
        }

        this.eventsModale = function() {
            $(document).on('click', '.tooltip-ticketing', function() {
                $(".modale-ticket-complaint")[0].style.display = "block";
                var modal = $('.modale-ticket-complaint').get(0);

                $(document).on('click', '.close-ticketing', function() {
                    $('.modale-ticket-complaint').get(0).style.display = "none";
                });
            });
        }

        this.createSelectMobile = function() {
            if (ticketingComplaint.responseTicketing !== null) {

                var lengthTypeValue = ticketingComplaint.responseTicketing.length;
                var values = ticketingComplaint.responseTicketing;
                if (lengthTypeValue > 0) {
                    var html = "";
                    html = html + "<div class='section__form'><div class='spaceBottom'>" +
                        "<div class='label-inside' data-component='AnimatedInputLabel'>" +
                        "<select class='form-control fc-edited' data-interest-select id='idsel2' required name='interestRateType'>";
                    var fineHtml = "</select>	<label for='idsel2'></label></div>" +
                        "<div class='errorMessages__idsel2'></div></div></div>";
                    for (var i = 0; i < lengthTypeValue; i++) {
                        var typeValue = ticketingComplaint.capitalizedString(values[i].typeValue);

                        html = html + "<option value=" + i + ">" + typeValue + "</option>";
                    }
                    $('[data-ticket-complaint]').get(0).innerHTML = html + fineHtml;
                }

            } else {
                console.log("Error with responseTicketing: null");
            }
        }



        this.createButtonTypeValue = function() {

            if (ticketingComplaint.responseTicketing !== null) {

                var lengthTypeValue = ticketingComplaint.responseTicketing.length;
                var values = ticketingComplaint.responseTicketing;
                if (lengthTypeValue > 0) {
                    var html = "";
                    for (var i = 0; i < lengthTypeValue; i++) {
                        var typeValue = ticketingComplaint.capitalizedString(values[i].typeValue);
                        var id = values[i].typeId;

                        html = html + "<a class='for__tabItem j-for__tabItem ticketing' tabindex='" + i + "' href='javascript:;' data-tab-id='" + id + "' data-tab='" + i + "' data-tab-value='" + typeValue + "|" + typeValue + "'>" +
                            "<div class='for__tabRect'><div class='for__tabInner'>" +
                            "<label class='container-complaints'>" + typeValue +
                            "<input type='radio' data-index-type-values='" + i + "' id='typeOfRequest' name='typeOfRequest' value='" + id + "'>" +
                            "<span class='checkmark-complaint'></span>" +
                            "</label></div></div></a>";
                    }
                    $('[data-ticket-complaint]').get(0).innerHTML = html;
                }

            } else {
                console.log("Error with responseTicketing: null");
            }
        }


        // method Buttons

        this.getActiveTypeValue = function(value) {

            var typeValue = value.getAttribute("data-tab-value").split("|")[0]
            var indexOfTypeValue = parseInt(value.getAttribute("data-tab"));
            var reasons = ticketingComplaint.responseTicketing[indexOfTypeValue].reasons;

            if (reasons.length > 0) {
                ticketingComplaint.activeReasons = reasons;
            }
        }

        this.attemptEventsTypeValue = function() {

            $(document).on('click', '[data-tab]', function() {
                ticketingComplaint.getActiveTypeValue(this);
                ticketingComplaint.setReasonOfWritingTypeValue();
                if ($(window).width() > 768) {
                    ticketingComplaint.attemptEventsReasonsWindows();
                } else {
                    ticketingComplaint.attemptEventsReasonsMobile();
                }

                var index = parseInt(this.getAttribute("data-tab"));
                ticketingComplaint.clearButtonTypeValue(this, index);

                var typeId = parseInt(this.getAttribute("data-tab-id"));
                $('input[name="typeId"]').val(typeId);


                $('[data-specify-type-container]').get(0).style.display = "none";

                ticketingComplaint.chooseTypeValue = typeId;

            });
            /*$(window).on('resize', function() {
                ticketingComplaint.setReasonOfWritingTypeValue();
                if ($('[data-specify-type-container]').get(0))
                    $('[data-specify-type-container]').get(0).style.display = "none";

                $(document).on('click', '[data-tab]', function() {
                    ticketingComplaint.getActiveTypeValue(this);
                    ticketingComplaint.setReasonOfWritingTypeValue();
                    if ($(window).width() > 768) {
                        ticketingComplaint.attemptEventsReasonsWindows();
                    } else {
                        ticketingComplaint.attemptEventsReasonsMobile();
                    }

                    var index = parseInt(this.getAttribute("data-tab"));
                    ticketingComplaint.clearButtonTypeValue(this, index);

                    var typeId = parseInt(this.getAttribute("data-tab-id"));
                    $('input[name="typeId"]').val(typeId);

                    $('[data-container-reason-complaint]').get(0).style.display = "block";
                    $('[data-specify-type-container]').get(0).style.display = "none";

                    ticketingComplaint.chooseTypeValue = typeId;
                });
            });*/
        }

        this.attemptEventsReasonsWindows = function(name) {

            $(document).on('click', '[data-tab-reason]', function() {
                ticketingComplaint.getActiveReasonsValue(this);
                ticketingComplaint.setSpecifyTypeValue(this.getAttribute("data-tab-value").split("|")[0]);
                //$('[data-specify-type-container]').get(0).style.display = "block";
                ticketingComplaint.attemptEventsSubReasons();
                this.classList.add("active");
                ticketingComplaint.clearButtonReasons(this, "[data-tab-reason]");
                ticketingComplaint.chooseReason = this.getAttribute("data-tab-value").split("|")[0];
                var reasonId = parseInt(this.getAttribute("data-tab-id"));
                $('input[name="reasonId"]').val(reasonId);
            });
        }
        this.attemptEventsReasonsMobile = function() {

            $(document).on('change', '[data-select-reason]', function() {

                console.log($(this).val());
                ticketingComplaint.getActiveReasonsValue(this);
                //$('[data-specify-type-container]').get(0).style.display = "block";
                ticketingComplaint.setSpecifyTypeValue($('[data-select-reason] option:selected').text());
                ticketingComplaint.attemptEventsSubReasonsMobile();

                var reasonId = $(this).val();
                $('input[name="reasonId"]').val(reasonId);

                // $('[data-specify-type-container]').get(0).style.display = "block";
            });

        }




        this.setReasonOfWritingTypeValue = function() {
            var values = ticketingComplaint.activeReasons;
            var lengthReasonsValue = values.length;
            $('[data-container-reason-complaint]').get(0).style.display = "none";
            if (lengthReasonsValue > 0) {
                var html = "";
                var checkTypeSegment = true;

                if ($(window).width() > 768) {

                    for (var i = 0; i < lengthReasonsValue; i++) {
                        checkTypeSegment = true;
                        var subReasonOfReason = values[i].subReasons;
                        for (var j = 0; j < subReasonOfReason.length && checkTypeSegment; j++) {

                            var subCategoriesOfSubReason = subReasonOfReason[j].subReasonSegmentList;

                            for (var z = 0; z < subCategoriesOfSubReason.length && checkTypeSegment; z++) {
                                if (subCategoriesOfSubReason[z].includes(ticketingComplaint.typeSegment)) {
                                    checkTypeSegment = false;
                                    $('[data-container-reason-complaint]').get(0).style.display = "block";
                                }
                            }

                        }

                        if (!checkTypeSegment) {
                            var reasonValue = ticketingComplaint.capitalizedString(values[i].reasonValue);
                            var reasonId = ticketingComplaint.capitalizedString(values[i].reasonId);

                            html = html + "<a class='for__tabItem j-for__tabItem' tabindex='" + i + "' href='javascript:;' data-tab-reason='" + i + "' " +
                                "data-tab-value='" + reasonValue + "|" + reasonValue + "' data-tab-id='" + reasonId + "'><div class='for__tabRect'><div class='for__tabInner'><span class='for__tabText'>" +
                                "<span class='for__tabImage icon-amount'></span>" + reasonValue + "</span></div></div></a>";
                        }
                    }
                    $('[data-reason-of-writing-complaint]').get(0).innerHTML = html;
                } else {
                		if(language.indexOf('sr') > -1){
                			  html = html + "<div class='section__form'><div class='spaceBottom'>" +
                              "<div class='label-inside' data-component='AnimatedInputLabel'>" +
                              "<select class='form-control fc-edited ticketing' data-interest-select data-select-reason id='idsel2' required name='interestRateType'>" +
                              "<option value='' selected>Izaberite oblast</option>";
                		}else if(language.indexOf('en') > -1){ 
                			html = html + "<div class='section__form'><div class='spaceBottom'>" +
                            "<div class='label-inside' data-component='AnimatedInputLabel'>" +
                            "<select class='form-control fc-edited ticketing' data-interest-select data-select-reason id='idsel2' required name='interestRateType'>" +
                            "<option value='' selected>Choose an Area</option>";
                		}
                    var fineHtml = "</select>	<label for='idsel2'></label></div>" +
                        "<div class='errorMessages__idsel2'></div></div></div>";

                    for (var i = 0; i < lengthReasonsValue; i++) {
                        checkTypeSegment = true;
                        var subReasonOfReason = values[i].subReasons;
                        for (var j = 0; j < subReasonOfReason.length && checkTypeSegment; j++) {

                            var subCategoriesOfSubReason = subReasonOfReason[j].subReasonSegmentList;

                            for (var z = 0; z < subCategoriesOfSubReason.length && checkTypeSegment; z++) {
                                if (subCategoriesOfSubReason[z].includes(ticketingComplaint.typeSegment)) {
                                    checkTypeSegment = false;
                                    $('[data-container-reason-complaint]').get(0).style.display = "block";
                                }
                            }

                        }

                        if (!checkTypeSegment) {
                            var reasonValue = ticketingComplaint.capitalizedString(values[i].reasonValue);
                            var idReason = values[i].reasonId;
                            html = html + "<option value='" + idReason + "'>" + reasonValue + "</option>";
                        }

                    }
                    $('[data-reason-of-writing-complaint]').get(0).innerHTML = html;
                }
            }
        }

        this.getActiveReasonsValue = function(value) {

            if ($(window).width() > 768) {
                var typeReasons = value.getAttribute("data-tab-value").split("|")[0];
                var indexOfTypeValue = parseInt(value.getAttribute("data-tab-reason"));
                var subReasons = ticketingComplaint.activeReasons[indexOfTypeValue].subReasons;

                if (subReasons.length > 0) {
                    ticketingComplaint.activeSubReasons = subReasons;
                }
            } else {
                var reasonId = parseInt($(value).val());
                for (var i = 0; i < ticketingComplaint.activeReasons.length; i++) {
                    if (parseInt(ticketingComplaint.activeReasons[i].reasonId) === reasonId) {
                        if (ticketingComplaint.activeReasons[i].subReasons.length > 0) {
                            ticketingComplaint.activeSubReasons = ticketingComplaint.activeReasons[i].subReasons;
                        }
                    }
                }
            }
        }

        this.attemptEventsSubReasons = function() {

            $(document).on('click', '[data-tab-subreason]', function() {
                this.classList.add("active");
                ticketingComplaint.clearButtonReasons(this, "[data-tab-subreasons]");
                ticketingComplaint.chooseSubReason = this.getAttribute("data-tab-value").split("|")[0];
                $("#data-tab").val(ticketingComplaint.chooseTypeValue + "|" + ticketingComplaint.chooseReason + "|" + ticketingComplaint.chooseSubReason);

                var subReasonId = parseInt(this.getAttribute("data-tab-id"));
                $('input[name="subReasonId"]').val(subReasonId);
            });
        }

        this.attemptEventsSubReasonsMobile = function() {

            $(document).on('change', '[data-select-subreason]', function() {
            	console.log($(this).val());
                ticketingComplaint.chooseSubReason = $(this).val();
                $("#data-tab").val(ticketingComplaint.chooseTypeValue + "|" + ticketingComplaint.chooseReason + "|" + ticketingComplaint.chooseSubReason);

                var subReasonId = $(this).val();
                $('input[name="subReasonId"]').val(subReasonId);
            });
        }

        this.setSpecifyTypeValue = function(name) {
            var values = ticketingComplaint.activeSubReasons;
            var lengthSpecifyTypeValue = values.length;
            var checkTypeSegment = true;
            if (lengthSpecifyTypeValue > 0) {
                var html = "";
                if ($(window).width() > 768) {
                    for (var i = 0; i < lengthSpecifyTypeValue; i++) {
                        checkTypeSegment = true;
                        var subCategoriesOfSubReason = values[i].subReasonSegmentList;
                        for (var z = 0; z < subCategoriesOfSubReason.length && checkTypeSegment; z++) {
                            if (subCategoriesOfSubReason[z].includes(ticketingComplaint.typeSegment)) {
                                checkTypeSegment = false;
                                $(".individuals-reason .for__gridWrapperTabs__title.specifyTitle").show();
                                $('[data-specify-type-container]').get(0).style.display = "block";
                            }
                        }

                        if (!checkTypeSegment) {
                            var subReasonValue = ticketingComplaint.capitalizedString(values[i].subReasonValue);
                            var subReasonId = ticketingComplaint.capitalizedString(values[i].subReasonId);

                            html = html + "<a class='for__tabItem j-for__tabItem' tabindex='" + i + "' href='javascript:;' data-tab-subreason='" + i + "' " +
                                "data-tab-value='" + subReasonValue + "|" + subReasonValue + "' data-tab-id='" + subReasonId + "'><div class='for__tabRect'><div class='for__tabInner'><span class='for__tabText'>" +
                                "<span class='for__tabImage icon-amount'></span>" + subReasonValue + "</span></div></div></a>";
                        }
                    }
                    $('[data-reason-of-specify-type]').get(0).innerHTML = html;
                } else {

                    $(".individuals-reason .for__gridWrapperTabs__title.specifyTitle").hide();
                    
                    if(language.indexOf('sr') > -1){
                        html = html + "<div class='section__form'><div class='spaceBottom'>" +
                        "<div class='label-inside' data-component='AnimatedInputLabel'>" +
                        "<select class='form-control fc-edited ticketing' data-interest-select data-select-subreason id='idsel3' required name='interestRateType'>" +
                        "<option value='' selected>Izaberite podoblast</option>" + "<optgroup label='" + name + "'>";
                    }else if(language.indexOf('en') > -1){ 
                        html = html + "<div class='section__form'><div class='spaceBottom'>" +
                        "<div class='label-inside' data-component='AnimatedInputLabel'>" +
                        "<select class='form-control fc-edited ticketing' data-interest-select data-select-subreason id='idsel3' required name='interestRateType'>" +
                        "<option value='' selected>Choose a Subcategory</option>" + "<optgroup label='" + name + "'>";
                    }
                    
                    var fineHtml = "</optgroup></select>	<label for='idsel2'></label></div>" +
                        "<div class='errorMessages__idsel2'></div></div></div>";

                    for (var i = 0; i < lengthSpecifyTypeValue; i++) {
                        var subCategoriesOfSubReason = values[i].subReasonSegmentList;
                        checkTypeSegment = true;
                        for (var z = 0; z < subCategoriesOfSubReason.length && checkTypeSegment; z++) {
                            if (subCategoriesOfSubReason[z].includes(ticketingComplaint.typeSegment)) {
                                checkTypeSegment = false;
                                $(".individuals-reason .for__gridWrapperTabs__title.specifyTitle").show();
                                $('[data-specify-type-container]').get(0).style.display = "block";
                            }
                        }

                        if (!checkTypeSegment) {
                            var subReasonValue = ticketingComplaint.capitalizedString(values[i].subReasonValue);
                            var subReasonId = ticketingComplaint.capitalizedString(values[i].subReasonId);
                            html = html + "<option value='" + subReasonId + "'>" + subReasonValue + "</option>";
                        }

                    }
                    $('[data-reason-of-specify-type]').get(0).innerHTML = html;
                }
            }
            $(".individuals-reason .for__gridWrapperTabs__title.specifyTitle").text(ticketingComplaint.textParagraph + " " + name);
        }

        this.clearButtonReasons = function(element, attribute) {

            var attributeContainer = "";
            if (attribute.includes("data-tab-reason")) {
                attributeContainer = "[data-reason-of-writing-complaint]";
            } else {
                attributeContainer = "[data-reason-of-specify-type]";
            }

            var length = $(attributeContainer).children().length;
            var index = parseInt(element.getAttribute("tabindex"));

            for (var i = 0; i < length; i++) {

                var a_element = $(attributeContainer).children()[i];

                if (a_element !== element) {
                    a_element.classList.remove('active');
                }
            }
        }

        this.clearButtonTypeValue = function(element, index) {
            element.classList.add("activeWhite");
            $("[data-index-type-values='" + index + "']").prop('checked', true);
            var lengthButton = $('[data-tab]').length;
            if (lengthButton > 0) {
                for (var i = 0; i < lengthButton; i++) {
                    if (i !== index) {
                        $("[data-index-type-values='" + i + "']").prop('checked', false);
                        $('[data-tab]')[i].classList.remove("activeWhite");
                    }
                }
            }

        }



        this.capitalizedString = function(string) {
            string = string.toUpperCase();
            return string[0].concat(string.substring(1, string.length).toLowerCase());
        }

        this.controlEmailAndPhone = function() {
            $('button[data-layer-bib-push]').on('click',function(){
            	if(ticketingComplaint.typeSegment != "LEGAL_ENTITY"){
                    if($('[data-ticket-complaint]').length > 0){
                            var valueMail = $('#item_email').val();
                	        var valuePhone = $('input[name="phoneNumber"]').val();
                	        if(valueMail == "" && valuePhone == ""){
                		        $('#item_email')[0].setAttribute("required",true);
                		        $('input[name="phoneNumber"]')[0].setAttribute("required",true);
                	        }
                	        else{
                		        $('input[name="phoneNumber"]')[0].removeAttribute("required");
                		        $('#item_email')[0].removeAttribute("required");
                	        }
                    }
            		
            	}
            });
        }

    }
    /**
     * Get class instance
     *
     */
Intesa.TicketingComplaint.getInstance = function() {

    if (!window.intesa) {
        window.intesa = new Object();
    }

    if (!window.intesa.ticketing_complaint) {
        window.intesa.ticketing_complaint = new Intesa.TicketingComplaint();
    }

    return window.intesa.ticketing_complaint;
};